<div [ngStyle]="{'padding-left': (isEval ? '0' : '20px')}">
    <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
    [legend]="lineChartLegend" [type]="lineChartType">
    </canvas>
</div>